( function( $ ) {
  var pageId = 'page-member-settings-background',
      page = '#' + pageId;

  var currentActiveButton = null;
  var uploadFileName = null;
  var hasClickSaveButton = false;
  var uploadFileSizeLimit = 1024 * 1024 * 10; // 10MB

  function activeButton(button) {
    if (button) {
      // Inactive button first.
      if (currentActiveButton) {
        inactiveButton(currentActiveButton);
      }

      // Active button with button type.
      if (button.data("type") == "color") {
        button.addClass("active")
      } else if (button.data("type") == "album_background" ||
                 button.data("type") == "default_background") {
        button.attr("src", button.data("active"))
      } else if (button.data("type") == "upload_background") {
        $(".re-upload-thumbnail-active-overlay").show();
      }

      // Update type and index attributes.
      $("#custom_background_type").val(button.data("type"));
      $("#custom_background_index").val(button.data("index"));

      // Save current active button.
      currentActiveButton = button;
    }
  }

  function inactiveButton(button) {
    // Inactive button with button type.
    if (button.data("type") == "color") {
      button.removeClass("active");
    } else if (button.data("type") == "album_background" ||
               button.data("type") == "default_background") {
      button.attr("src", button.data("normal"))
    } else if (button.data("type") == "upload_background") {
      $(".re-upload-thumbnail-active-overlay").hide();
    }
  }

  function uploadPreparation(file, isUploadForm) {
    if (file.size > uploadFileSizeLimit) {
      if (isUploadForm) {
        $(".upload-item").hide();
      } else {
        $(".re-upload-item").hide();
      }

      $(".upload-progress")
        .text("上传的图片不能超过10MB，请重新上传一张图片")
        .show();

      setTimeout(function(){
        $(".upload-progress").hide();

        if (isUploadForm) {
          $(".upload-item").show();
        } else {
          $(".re-upload-item").show();
        }
      }, 2000);
    } else {
      /* Upload automatically when file change */
      uploadFileName = file.name;

      if (isUploadForm) {
        $(".upload-form").submit();
      } else {
        $(".re-upload-form").submit();
      }
    }
  }

  function uploadImage(formTarget) {
    // Change active button before upload image
    activeButton($(".re-upload-thumbnail-background"));

    // Get form data and append connection id
    var formData = new FormData(formTarget);
    formData.append("conn_guid", $("#conn-guid").val())

    // Init progress.
    $(".upload-progress")
      .text("正在上传")
      .show();

    // Submit now.
    $.ajax({
      url: '/users/upload_background',
      type: 'POST',
      data: formData,

      // Tell jQuery not to process data or worry about content-type.
      cache: false,
      contentType: false,
      processData: false,

      // Custom XMLHttpRequest for monitor upload progress.
      xhr: function() {
        var uploadXhr = $.ajaxSettings.xhr();
        if (uploadXhr.upload) {
          // For handling the progress of the upload.
          uploadXhr.upload.addEventListener('progress', function(e) {
            if (e.lengthComputable) {
              // Reset input value to make user can upload image again.
              // Otherwise, input's change signal won't trigger.
              if (e.loaded == e.total) {
                $("#upload-link").val("")
                $("#re-upload-link").val("")
              }

              // Change progress to 99 when upload file finish to wait backend response.
              var progress = e.loaded == e.total ? 99 : e.loaded / e.total * 100;

              // Update progress.
              $(".upload-progress")
                .text("正在上传 " + Math.floor(progress) + "% (" + uploadFileName + ") ...")
                .show();
            }
          } , false);
        }

        return uploadXhr;
      }
    });
  }

  $(function() {
    $('body')
      .on("click", page + " .default-color", function(e) {
        e.preventDefault();

        activeButton($(e.target));

        tower.updateCustomBackgroundColor($(e.target));
      })
      .on("click", page + " .default-background img", function(e) {
        e.preventDefault();

        activeButton($(e.target));

        tower.updateCustomBackgroundImage(
          $(e.target).data("imageAssetPath"),
          $(e.target).data("imageAssetPath"),
          $(e.target).data("topBrightness"),
          $(e.target).data("bottomBrightness")
        );
      })
      .on("click", page + " .re-upload-thumbnail", function(e) {
        e.preventDefault();

        activeButton($(".re-upload-thumbnail-background"));

        $.ajax({
          url: "/users/upload_background",
          method: "get",
          success: function(result) {
            if (result["success"]) {
              tower.updateCustomBackgroundImage(
                result["background_url"],
                result["thumbnail_url"],
                result["top_brightness"],
                result["bottom_brightness"]
              );
            }
          }
        })
      })
      .on("click", page + " .album-background img", function(e) {
        e.preventDefault();

        activeButton($(e.target));

        // Click album background item to get next random image url.
        $.ajax({
          url: '/users/custom_background/album_random',
          method: 'get',
          data: {
            category: $(e.target).data("category")
          },
          success: function(result) {
            if (result["success"]) {
              tower.updateCustomBackgroundImage(result["image_url"], result["image_url"], result["top_brightness"], result["bottom_brightness"]);
            }
          }
        })
      })
      .on("click", page + " .btn-save", function(e) {
        e.preventDefault();

        $.ajax({
          url: "/users/background_setting",
          method: "patch",
          data: {
            custom_background: $("#custom_background").val(),
            custom_background_url: $("#custom_background_url").val(),
            custom_background_type: $("#custom_background_type").val(),
            custom_background_top_brightness: $("#custom_background_top_brightness").val(),
            custom_background_bottom_brightness: $("#custom_background_bottom_brightness").val(),
            custom_background_index: $("#custom_background_index").val()
          },
          success: function(result) {
            if (result.success && result.target_url) {
              // Don't popup reload confirm dialog if user click save button to change current url.
              hasClickSaveButton = true;

              // Redirect to setting page.
              location.href = result.target_url;
            }
          }
        })
      })
      .on("click", page + " .upload-delete-button", function(e) {
        e.preventDefault();

        // Only switch to first color if current type is upload_background.
        if ($("#custom_background_type").val() == "upload_background") {
          var firstColorButton = $($(".default-color")[0]);
          activeButton(firstColorButton);

          tower.updateCustomBackgroundColor(firstColorButton);
        }

        // Reset upload attributes.
        $.ajax({
          url: "/users/upload_background",
          method: "delete"
        })

        // Adjust upload form.
        $(".re-upload-item").hide();
        $(".upload-item").show();
      })
      .on("change", page + " #upload-link", function(e) {
        uploadPreparation(this.files[0], true);
      })
      .on("submit", page + " .upload-form", function(e) {
        e.preventDefault();

        $(".upload-item").hide();
        uploadImage(this);
      })
      .on("change", page + " #re-upload-link", function(e) {
        uploadPreparation(this.files[0], false);
      })
      .on("submit", page + " .re-upload-form", function(e) {
        e.preventDefault();

        $(".re-upload-item").hide();
        uploadImage(this);
      })
  });

  $(document).on('pjaxload#' + pageId, function(e, $page, page) {
    // Active button when first load current page.
    var initBackgroundType = $("#custom_background_type").val();
    var initBackgroundIndex = $("#custom_background_index").val();
    var initBackground = $("#custom_background").val();

    var button = null;

    if (initBackgroundType == "color") {
      button = $($page.find(".default-color")[initBackgroundIndex - 1]);
    } else if (initBackgroundType == "default_background") {
      button = $($page.find(".default-background img")[initBackgroundIndex - 1]);
    } else if (initBackgroundType == "album_background") {
      button = $($page.find(".album-background img")[initBackgroundIndex - 1]);
    } else if (initBackgroundType == "upload_background") {
      button = $($page.find(".re-upload-thumbnail-background")[0]);
    }

    activeButton(button);

    // Update custom background thumbnail if user has upload one.
    $.ajax({
      url: "/users/upload_background",
      method: "get",
      success: function(result) {
        if (result["success"]) {
          var initBackgroundThumbnail = result["thumbnail_url"]
          if (initBackgroundThumbnail != "") {
            $(".upload-item").hide();
            $(".re-upload-thumbnail-background").attr("src", initBackgroundThumbnail);
            $(".re-upload-item").show();
          }
        }
      }
    })

    // Popup dialog if current background is not save before reload page.
    window.addEventListener("beforeunload", function (e) {
      if (!hasClickSaveButton && initBackground != $("#custom_background").val()) {
        var confirmationMessage = "";
        (e || window.event).returnValue = confirmationMessage;
        return confirmationMessage;
      }
    });
  });
})( jQuery );
